<template>
  <div class="address_html">
    <div class="search">
      <div class="search-box">
        <div class="isPopup" v-if="isPopup"><van-icon @click="isBack" name="arrow-left" /></div>
        <van-search
            v-scrolltop
            v-model="value"
            placeholder="请输入搜索关键词"
            show-action
            shape="round"
            @search="onSearch"
            @clear="onClear"
        >
          <div slot="action" @click="onSearch">搜 索</div>
        </van-search>
      </div>
<!--      <div class="selected" v-if="userAddress.length > 0">-->
<!--        <h5>已选择</h5>-->
<!--        &lt;!&ndash;<span @click="empty">清 空</span>&ndash;&gt;-->
<!--        <ul>-->
<!--          <li-->
<!--            v-for="(item, index) in userAddress"-->
<!--            :key="index"-->
<!--            @click="userAddressChange(item, index)"-->
<!--          >-->
<!--            {{ item.name }}-->
<!--          </li>-->
<!--        </ul>-->
<!--      </div>-->
      <div class="selected" v-if="userAddress.length > 0">
        <h5><van-icon style="margin-right:5px;" name="wap-home" color="#333" size="14px"/>当前地址</h5>
        <!--<span @click="empty">清 空</span>-->
        <div class="address_ul">
          <ul>
            <li v-for="(item, index) in userAddress"
                :key="index"
                @click="userAddressChange(item, index)">
                {{ item.name }}
              <van-icon v-if="userAddress.length-1 === index" name="success" color="#00982d"/>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="address-body"
      :class="userAddress.length > 0 ? 'hasUserAddress' : ''"
    >
      <div class="regionList">
        <template v-for="(item, index) in regionList">
          <van-cell @click="region(item, index)">
            <template slot="title">
              <span
                >{{ item.Name }}
                <span v-if="item.ExtendName"
                  >（{{ item.ExtendName }}）</span
                ></span
              >
            </template>
          </van-cell>
        </template>
      </div>
    </div>
<!--    <div class="Sure_btn" @click="submitChangeAddr">确定更换</div>-->
  </div>
</template>

<script>
import {setCookie, getCookie, removeCookie} from "@/utils/cookie";
import {getWeixInfo, setWeixInfo} from "@/utils/auth";

export default {
  props: {
    isPopup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showAction: false,
      value: "",
      regionList: [],
      index: 0,
      userAddress: [],
      listType: "",
    };
  },
  methods: {
    isBack(){
      this.$emit('close')
    },
    submitChangeAddr() {
      if (this.isPopup) {
        if (this.regionList.length) {
          this.$toast("当前地址暂未开通服务，请重新选择！");
          return false;
        }
        this.$emit('changeAddr', this.userAddress)
      }else {
        this.submitChange()
      }
    },
    submitChange() {
      if (this.regionList.length) {
        this.$toast("当前地址暂未开通服务，请重新选择！");
        return false;
      }
      const params = {
        Id: JSON.parse(getWeixInfo()).Id,
        DormitoryId: this.userAddress[this.userAddress.length -1].Id
      }
      this.$post('/BizMemberMember/UpdateDormitory', params).then(res => {
        if (res.Status === 1) {
          if (res.Data.Tip) {
            this.$dialog.alert({
              type: 'info',
              title: '提示',
              message: res.Data.Tip
            }).then(() => {
              this.$router.replace({name: 'orderDetails', query: {Id: res.Data.OrderId, isPay: true}})
              // on close
            })
          }else {
            this.$toast({
              icon: 'success',
              message: res.Message,
            });
            this.$router.replace({name: 'user', params: { refresh: true }})
          }
          removeCookie('userAddressCache')
        }else {
          this.$toast({
            icon: 'fail',
            message: res.Message,
          });
        }
      })
    },
    empty() {
      this.userAddress = [];
    },
    userAddressChange(item, index, type = true) {
      // 筛选地址导航 根据点击数组的下标删除比下标大的数组项，并且根据当前点击判断请求接口， 如果大于0 则请求校区接口，然请求宿舍接口，传上一个userAddress数组的Id作为ParentId，如果上一个是userAddress数组的第一个，则直接请求校区接口
      const params = {};
      if (this.listType !== "onSearch") {
        this.value = "";
      }
      if (index === 0) {
        // 当地址导航点击下标为0时
        this.userAddress = []; // 清空
        this.getregionList();
      } else {
        this.userAddress = this.userAddress.filter(function (item, uIndex) {
          // 删除比当前点击下标大的数组
          return uIndex < index;
        });
        if (index === 1) {
          params.RegionId = this.userAddress[0].Id;
        } else {
          params.RegionId = this.userAddress[0].Id;
          params.ParentId = this.userAddress[index - 1].Id;
        }
        if (this.$route.query.isCache) {
          setCookie('userAddressCache', JSON.stringify(this.userAddress))
        }
        this.getList(params);
      }
    },
    onSearch() {
      this.listType = "onSearch";
      if (this.userAddress.length <= 0) {
        // 已选择地址 小于等于0时u，直接请求校区
        this.getregionList();
        return false;
      } // 否则请求
      const item = this.userAddress[this.userAddress.length - 1];
      this.userAddressChange(item, this.userAddress.length, false);
    },
    onClear() {
      this.onSearch();
    },
    getregionList() {
      this.$toast.loading();
      const params = { Name: this.value };
      this.$post("/BizMemberRegion/AllList", params).then((res) => {
        if (res) {
          this.index = 0;
          this.regionList = res.Data;
          this.$toast.loading().clear();
        }
      });
    },
    getList(val) {
      this.$toast.loading();
      const params = val;
      params.Name = this.value;
      this.regionList = []
      this.$post("/BizMemberDormitory/AllList", params).then((res) => {
        if (res) {
          if (res.Data.length > 0) {
            this.regionList = res.Data;
          } else {
            this.regionList = []
            // 如果已经加载完子级，则返回已选中的数据 this.userAddress
            // this.$router.go(-1);
            this.$store.dispatch("setAddress", this.userAddress);
          }
          if (this.listType === "onSearch") {
            this.listType = "";
          }
          this.$toast.loading().clear();
        }
      });
    },
    region(item, index) {
      // 地址点击
      this.value = "";
      this.$toast.loading();
      this.index++; // 设置点击次数，区分传参
      const params = {};
      if (this.index === 1) {
        // 判断当前点击为第一级的传参
        if (params.ParentId !== "") {
          this.$delete(params, "ParentId");
        }
        this.RegionId = item.Id; // 存下第一级参数
      } else {
        // 大于1的传参
        params.ParentId = item.Id;
      }
      if (item.ExtendName !== undefined) {
        this.userAddress.push({
          name: item.Name + "(" + item.ExtendName + ")",
          Id: item.Id,
        });
      } else {
        this.userAddress.push({
          name: item.Name,
          Id: item.Id,
          IsLeaf: item.IsLeaf
        });
      }
      params.RegionId = this.RegionId;
      if (this.$route.query.isCache) {
        setCookie('userAddressCache', JSON.stringify(this.userAddress))
      }
      this.getList(params);
    },
    init() {

    }
  },
  mounted() {
    if (!this.$route.query.isCache) {
      this.getregionList();
      return false
    }
    const userAddressCache = getCookie('userAddressCache')
    if (userAddressCache) {
      this.userAddress = JSON.parse(userAddressCache)
      const params = {
        RegionId: this.userAddress[0].Id
      }
      if (this.userAddress.length > 1) {
        params.ParentId = this.userAddress[this.userAddress.length - 1].Id
      }
      this.index = this.userAddress.length
      if(this.userAddress.length === 4) return false
      this.getList(params)
    }else {
      this.getregionList();
    }
  },
};
</script>

<style scoped lang="less">
.address_html{
  height: 100%;
  overflow-y: auto;
  //overflow: hidden;
}
.Sure_btn{
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #48bd4b;
  text-align: center;
  height: 48px;
  color: #fff;
  line-height: 48px;
  font-size: 16px;
}
.address_ul{
  padding:10px;
  background: #fff;
  border-bottom:4px solid #eee;
}
.address_ul li{
  display: flex;
  justify-content: space-between;
  padding:5px 0;
  color:#333;
}
.address_ul li:first-child{
  color:#303133;
  font-size:14px;
  font-weight: bold;
  &:after {
    display: none;
  }
}
.address_ul li i{
  display: none;
}
.address_ul li:last-child i{
  display: initial;
}
.address-body {
  //height: 100%;
  //overflow-y: auto;
  padding-bottom:48px;
  &.hasUserAddress {

  }
}
.search {
  width: 100%;
  z-index: 9;
  h5 {
    color: #333;
    padding: 10px;
    margin: 0;
    font-weight: normal;
  }

}

.search-box{
  display: flex;

  .van-search{
    width: 100%;
  }
  .isPopup{
    height: 64px;
    width: 30px;
    line-height: 64px;
    flex-shrink: 0;
    text-align: center;
  }
}
.selected {
  background: #f2f2f2;
  overflow: hidden;
  > span {
    display: inline-block;
    line-height: 25px;
    float: left;
    padding: 0 10px;
    -webkit-border-radius: 200px;
    -moz-border-radius: 200px;
    border-radius: 200px;
    background: #f6f6f6;
    color: #999;
    margin-right: 10px;
  }
  //ul {
  //  overflow: hidden;
  //  padding: 5px 10px;
  //  float: left;
  //  li {
  //    list-style: none;
  //    float: left;
  //    font-size: 12px;
  //    color: #999;
  //    &:after {
  //      content: ">";
  //      margin: 0 2px;
  //    }
  //    &:last-child {
  //      color: #666;
  //      &:after {
  //        display: none;
  //      }
  //    }
  //  }
  //}
}
</style>
